// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a98216e0","455":"98cf93b3"}[chunkId] + ".chunk.js";
};